import React from 'react'
import SVGIcon from '../svg/SVGIcon'
import s from './MenuCategoryItem.less'
import { buildStyleAttributes, hexToRgb } from '../utils/css'

const MenuCategoryItem = ({ id, shortLabel, iconId, color, selected, active, onMouseOver, onCategoryClick }) => {
  const labelStyle = {}
  const iconStyle = {}

  if (selected) {
    iconStyle.borderColor = color
    iconStyle.backgroundColor = color
    iconStyle.fill = 'white'
    labelStyle.color = color
  } else if (active) {
    iconStyle.borderColor = hexToRgb(color, 0.5)
    iconStyle.fill = color
  }

  return (
    <li key={id} className={s.category} onClick={onCategoryClick}>
      <div className={s.categoryItem}>
        <span className={s.categoryIcon} onMouseOver={onMouseOver} style={buildStyleAttributes(iconStyle)}>
          {__BROWSER__ && <SVGIcon icon={iconId} />}
        </span>
        <span className={s.categoryLabel} style={buildStyleAttributes(labelStyle)}>
          {shortLabel}
        </span>
      </div>
    </li>
  )
}

export default MenuCategoryItem
